import {
  DemandeAffiliationDocumentTypeEnum,
  PieceJustificativeDocumentTypeEnum,
} from '@graphql/generated';
import { DocumentType } from '@lib/ged/document-types.type';

export class DocumentTypeMapper {
  public static fromGraphQl(documentType?: string): DocumentType | undefined {
    const mapping: Record<string, DocumentType> = {
      // Affiliation
      PIECE_IDENTITE: 'pieceIdentite',
      JOURNEE_DECOUVERTE: 'journeeDecouverte',
      ESP: 'esp',
      CARTE_T: 'carteT',
      KBIS: 'kbis',
      STATUTS_SOCIETE: 'statutSociete',

      CONTRAT_AGENT_CO: 'contrat_agent_co',
      CONTRAT_INTERMED_ASSU: 'contrat_intermed_assu',
      CONTRAT_INTERMED_FIN: 'contrat_intermed_fin',
      CONVENTION_PRODEMIAL: 'convention_prodemial',
      MANDAT_STELLIUM_FIN: 'mandat_stellium_fin',
      SOUS_MANDAT_ENTREMISE: 'sous_mandat_entremise',

      // ValidationPj
      PHOTO_IDENTITE: 'photo_identite',
      RCP: 'rcp',
      RIB_AGC: 'rib_agc',
      RIB_PL: 'rib_pl',
      RIB_SOC: 'rib_soc',
      RSAC: 'rsac',
      ATT_VIGILANCE_SOC: 'attestation_vigilance_soc',
      ATT_VIGILANCE_AGC: 'attestation_vigilance_agc',
      ATT_VIGILANCE_PL: 'attestation_vigilance_pl',
      NOTIF_AFFILIATION_SOC: 'notification_affiliation_soc',
      NOTIF_AFFILIATION_AGC: 'notification_affiliation_agc',
      NOTIF_AFFILIATION_PL: 'notification_affiliation_pl',
      CERFA_3558_AGC: 'cerfa_3558_agc',
      CERFA_3558_SOC: 'cerfa_3558_soc',
      CERFA_3558_PL: 'cerfa_3558_pl',
      CERFA_3666_SOC: 'cerfa_3666_soc',
      CERFA_3666_AGC: 'cerfa_3666_agc',
      CERFA_3666_PL: 'cerfa_3666_pl',
      AVENANT_MIF2_ALPSI: 'avenant_mif2_alpsi',
      AVENANT_MIF2_CIF: 'avenant_mif2_cif',
      CONV_DISTRIB_INVEST: 'conv_distrib_invest',
      CERFA_CCI: 'cerfa_cci',
      ATTESTATION_COLLABORATEUR: 'attestation_collaborateur',
      CARTE_TRANSACTION: 'carte_transaction',
      CARTE_VITALE: 'carte_vitale',
      CONTRAT_APPRENTISSAGE: 'contrat_apprentissage',
      CNI: 'cni',
      DIPLOME: 'diplome',
      KBIS_PL: 'kbis_pl',
      KBIS_SOC: 'kbis_soc',
      ACTE_NAISSANCE: 'acte_naissance',
      ATT_FORMATION: 'attestation_formation',
      ATT_HABILITATION_IMMO: 'attestation_habilitation_immo',
      IMMAT_ORIAS_ALPSI: 'immatriculation_orias_alpsi',
      IMMAT_ORIAS_CIF: 'immatriculation_orias_cif',
      IMMAT_ORIAS_IOB: 'immatriculation_orias_iob',
      IMMAT_ORIAS_MIA: 'immatriculation_orias_mia',
      JUSTIFICATIF_DOMICILE: 'justificatif_domicile',
      LIVRET_FAMILLE: 'livret_famille',
      MANDAT_ALPSI: 'mandat_alpsi',
      PASSEPORT: 'passeport',
      CASIER_JUDICIAIRE_B3: 'casier_judiciaire_b3',
      STATUT_SOCIETE: 'statut_societe',
      CERTIFICAT_TRAVAIL: 'certificat_travail',
      TITRE_SEJOUR: 'titre_sejour',
      SYNTHESE_COMPTE_URSSAF: 'capture_synthese_compte_urssaf',
      NOTIF_DELAI_URSSAF: 'notif_demande_delai_urssaf',
      FORMATION_CONTINUE_IMMO: 'formation_continue_immo',
      FORMATION_CONTINUE_ASSU: 'formation_continue_assu',
      FORMATION_CONTINUE_FIN: 'formation_continue_financement',
      CONT_AGENT_CO: 'contrat_agent_commercial',
    };
    return documentType ? mapping[documentType] : undefined;
  }

  public static toGraphQl = (
    documentType?: DocumentType
  ):
    | DemandeAffiliationDocumentTypeEnum
    | PieceJustificativeDocumentTypeEnum
    | undefined => {
    const mapping: Record<
      DocumentType,
      DemandeAffiliationDocumentTypeEnum | PieceJustificativeDocumentTypeEnum
    > = {
      // Affiliation
      pieceIdentite: DemandeAffiliationDocumentTypeEnum.PieceIdentite,
      journeeDecouverte: DemandeAffiliationDocumentTypeEnum.JourneeDecouverte,
      esp: DemandeAffiliationDocumentTypeEnum.Esp,
      carteT: DemandeAffiliationDocumentTypeEnum.CarteT,
      kbis: DemandeAffiliationDocumentTypeEnum.Kbis,
      statutSociete: DemandeAffiliationDocumentTypeEnum.StatutsSociete,
      contrat_agent_co: DemandeAffiliationDocumentTypeEnum.ContratAgentCo,
      contrat_intermed_assu: DemandeAffiliationDocumentTypeEnum.ContratIntermedAssu,
      contrat_intermed_fin: DemandeAffiliationDocumentTypeEnum.ContratIntermedFin,
      convention_prodemial: DemandeAffiliationDocumentTypeEnum.ConventionProdemial,
      mandat_stellium_fin: DemandeAffiliationDocumentTypeEnum.MandatStelliumFin,
      sous_mandat_entremise: DemandeAffiliationDocumentTypeEnum.SousMandatEntremise,

      // Habilitation ou PJ
      kbis_pl: PieceJustificativeDocumentTypeEnum.KbisPl,
      kbis_soc: PieceJustificativeDocumentTypeEnum.KbisSoc,
      photo_identite: PieceJustificativeDocumentTypeEnum.PhotoIdentite,
      rcp: PieceJustificativeDocumentTypeEnum.Rcp,
      rib_agc: PieceJustificativeDocumentTypeEnum.RibAgc,
      rib_pl: PieceJustificativeDocumentTypeEnum.RibPl,
      rib_soc: PieceJustificativeDocumentTypeEnum.RibSoc,
      rsac: PieceJustificativeDocumentTypeEnum.Rsac,
      attestation_vigilance_agc: PieceJustificativeDocumentTypeEnum.AttVigilanceAgc,
      attestation_vigilance_pl: PieceJustificativeDocumentTypeEnum.AttVigilancePl,
      attestation_vigilance_soc: PieceJustificativeDocumentTypeEnum.AttVigilanceSoc,
      notification_affiliation_agc:
        PieceJustificativeDocumentTypeEnum.NotifAffiliationAgc,
      notification_affiliation_pl: PieceJustificativeDocumentTypeEnum.NotifAffiliationPl,
      notification_affiliation_soc:
        PieceJustificativeDocumentTypeEnum.NotifAffiliationSoc,
      cerfa_3558_agc: PieceJustificativeDocumentTypeEnum.Cerfa_3558Agc,
      cerfa_3558_pl: PieceJustificativeDocumentTypeEnum.Cerfa_3558Pl,
      cerfa_3558_soc: PieceJustificativeDocumentTypeEnum.Cerfa_3558Soc,
      cerfa_3666_agc: PieceJustificativeDocumentTypeEnum.Cerfa_3666Agc,
      cerfa_3666_pl: PieceJustificativeDocumentTypeEnum.Cerfa_3666Pl,
      cerfa_3666_soc: PieceJustificativeDocumentTypeEnum.Cerfa_3666Soc,
      acte_naissance: PieceJustificativeDocumentTypeEnum.ActeNaissance,
      attestation_formation: PieceJustificativeDocumentTypeEnum.AttFormation,
      attestation_habilitation_immo:
        PieceJustificativeDocumentTypeEnum.AttHabilitationImmo,
      avenant_mif2_alpsi: PieceJustificativeDocumentTypeEnum.AvenantMif2Alpsi,
      avenant_mif2_cif: PieceJustificativeDocumentTypeEnum.AvenantMif2Cif,
      conv_distrib_invest: PieceJustificativeDocumentTypeEnum.ConvDistribInvest,
      cerfa_cci: PieceJustificativeDocumentTypeEnum.CerfaCci,
      attestation_collaborateur:
        PieceJustificativeDocumentTypeEnum.AttestationCollaborateur,
      attestation_collab_cci: PieceJustificativeDocumentTypeEnum.AttestationCollaborateur,
      carte_transaction: PieceJustificativeDocumentTypeEnum.CarteTransaction,
      carte_vitale: PieceJustificativeDocumentTypeEnum.CarteVitale,
      cni: PieceJustificativeDocumentTypeEnum.Cni,
      contrat_apprentissage: PieceJustificativeDocumentTypeEnum.ContratApprentissage,
      diplome: PieceJustificativeDocumentTypeEnum.Diplome,
      immatriculation_orias_alpsi: PieceJustificativeDocumentTypeEnum.ImmatOriasAlpsi,
      immatriculation_orias_cif: PieceJustificativeDocumentTypeEnum.ImmatOriasCif,
      immatriculation_orias_iob: PieceJustificativeDocumentTypeEnum.ImmatOriasIob,
      immatriculation_orias_mia: PieceJustificativeDocumentTypeEnum.ImmatOriasMia,
      justificatif_domicile: PieceJustificativeDocumentTypeEnum.JustificatifDomicile,
      livret_famille: PieceJustificativeDocumentTypeEnum.LivretFamille,
      mandat_alpsi: PieceJustificativeDocumentTypeEnum.MandatAlpsi,
      passeport: PieceJustificativeDocumentTypeEnum.Passeport,
      casier_judiciaire_b3: PieceJustificativeDocumentTypeEnum.CasierJudiciaireB3,
      statut_societe: PieceJustificativeDocumentTypeEnum.StatutSociete,
      certificat_travail: PieceJustificativeDocumentTypeEnum.CertificatTravail,
      titre_sejour: PieceJustificativeDocumentTypeEnum.TitreSejour,
      capture_synthese_compte_urssaf:
        PieceJustificativeDocumentTypeEnum.SyntheseCompteUrssaf,
      notif_demande_delai_urssaf: PieceJustificativeDocumentTypeEnum.NotifDelaiUrssaf,
      formation_continue_immo: PieceJustificativeDocumentTypeEnum.FormationContinueImmo,
      formation_continue_assu: PieceJustificativeDocumentTypeEnum.FormationContinueAssu,
      formation_continue_financement:
        PieceJustificativeDocumentTypeEnum.FormationContinueFin,
      contrat_agent_commercial: PieceJustificativeDocumentTypeEnum.ContAgentCo,
    };
    return documentType ? mapping[documentType] : undefined;
  };
}
